import * as React from 'react'
import { type KeyboardEvent, useCallback } from 'react'
import { Field } from 'formik'

import { BaseTextField } from '@user/components/Formik'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'

export function Duration() {
  const tidalThemeActive = useTidalThemeActive()

  const onKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === '.') e.preventDefault()
  }, [])

  return (
    <Field
      required
      size={tidalThemeActive ? 'medium' : 'small'}
      type="number"
      name="duration"
      onKeyDown={onKeyDown}
      component={BaseTextField}
      label="Duration (minutes)"
      // 1 minute min 24 hour max
      inputProps={{
        min: 1,
        max: 1440,
        'data-test-id': 'filters-duration',
      }}
    />
  )
}
